// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec987076","239":"b14c4faa","732":"5434564c"}[chunkId] + ".chunk.js";
};